const fetchMyStore = async (query) => {
  const API_TOKEN = "08c335ba7bb59719618c612631ee7247";
  return await fetch(
    "https://pokeca-goodgame.myshopify.com/api/2024-04/graphql.json",
    {
      //[shop-name]にurlのショップ名を入力
      method: "POST",
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": API_TOKEN, //Storefront APIのアクセストークンを入力
      },
      body: query,
    }
  ).then((response) => response.json());
};

new Swiper(".swiper",{
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 1000,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    700: {
      slidesPerView: 2
    }
  }
});

document.addEventListener("click", (event) => {
  const tab = event.target.closest(".variant-options .option[data-variant-id]");
  if (!tab) return;

  const productId = tab.dataset.productId;
  const variantId = tab.dataset.variantId;
  const options = tab.parentNode;
  const values = options.nextElementSibling;

  Array.from(options.children).forEach((option) => {
    if (option.dataset.variantId === variantId) {
      option.classList.add("active");
    } else {
      option.classList.remove("active");
    }
  });

  Array.from(values.children).forEach((value) => {
    if (value.id === `variant-${productId}-${variantId}`) {
      value.classList.add("active");
    } else {
      value.classList.remove("active");
    }
  });
});

const suggestInit = () => {
  const titleList = (data) => {
    const list = data.map((item) => item.node.title);
    const result = new Set(list);
    return Array.from(result);
  };
  const setQuery = (text) => {
    const query = `{
      products(first:250, query: "${text}", sortKey: RELEVANCE) {
        edges {
          node {
            handle,
            title
          }
        }
      }
    }`;
    return query;
  };

  const onSuggest = (id) => {
    const input = document.getElementById(id + "-input");
    if (!input) return;
    const suggest = new Awesomplete(input, {
      minChars: 1,
      autoFirst: false,
      maxItems: 10,
    });

    input.addEventListener("input", (event) => {
      // document.body.classList.remove("body-lock");
      // document.querySelector(".hamburger").classList.remove("active");
      // document.querySelector(".drawer").classList.remove("open");
      fetchMyStore(setQuery(event.target.value)).then((response) => {
        const data = response.data.products.edges;
        suggest.list = titleList(data);
      });
    });

    input.addEventListener("awesomplete-select", (event) => {
      window.location.href = `/search?type=product&q=${event.text.value}`;
    });
  };

  onSuggest("headerSearch");
};

suggestInit();
